'use strict';

export default class ProductArchive {
    constructor(el) {
        this.rootElement = el;
        this.primaryFilter = document.getElementById('primary-filter');
        this.secondaryFilter = document.getElementById('secondary-filter');
        this.status = document.getElementById('filter-status');

        this.primaryButton = this.primaryFilter.querySelector('.menu-toggle');
        this.primaryChoices = this.primaryFilter.querySelectorAll('.menu-option');
        this.primarySelection = null;
        this.primaryButtonDefaultText = 'All Types';

        this.primaryChoices.forEach(el => {
            el.addEventListener('click', this.onPrimaryChoiceClick.bind(this))
        });

        this.secondaryButton = this.secondaryFilter.querySelector('.menu-toggle');
        this.secondaryChoices = null;
        this.secondarySelection = null;
        this.secondaryButtonDefaultText = 'All Subtypes';
        this.secondaryMenu = document.getElementById('product-subtype-menu');

        this.terms = window.terms;
        this.selectedOptionClass = 'selected';
        this.currentType = this.primaryFilter.querySelector('.current-type');

        // on child term archives, we auto-load the subtypes
        this.maybePopulateSecondary();

        this.initPagination();
    }

    maybePopulateSecondary() {
        if (this.currentType) {
            this.populateSecondaryOptions(parseInt(this.currentType.dataset.value));
        }
    }

    clearFilters() {
        this.getProducts(this.rootElement.dataset.urlBase);

        this.secondaryChoices.forEach(el => {
            el.classList.remove('selected');
        });
        this.secondaryButton.textContent = this.secondaryButtonDefaultText;
        this.secondarySelection = null;

        if (!this.currentType) {
            this.primarySelection = null;
            this.primaryButton.textContent = this.primaryButtonDefaultText;
            this.primaryChoices.forEach(el => {
                el.classList.remove('selected');
            });
            this.populateSecondaryOptions(null);
        }
        this.updateStatus();
    }

    updateStatus() {
        if (!this.primarySelection && !this.secondarySelection) {
            this.status.innerHTML = 'No filters selected';
            return;
        }
        const button = document.createElement('button');
        button.innerHTML = `<svg aria-hidden="true" width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 0a8.33 8.33 0 0 0-5.893 2.441 8.33 8.33 0 0 0 0 11.785 8.33 8.33 0 0 0 11.785 0 8.33 8.33 0 0 0 0-11.785A8.33 8.33 0 0 0 9 0Zm3.541 10.691v.001a.833.833 0 1 1-1.183 1.175L9 9.51l-2.35 2.358a.832.832 0 0 1-1.184 0 .834.834 0 0 1 0-1.175l2.359-2.358-2.359-2.359A.834.834 0 0 1 6.65 4.8L9 7.159 11.35 4.8a.833.833 0 0 1 1.183 0 .834.834 0 0 1 0 1.175l-2.35 2.359 2.358 2.357Z" fill="currentColor"/></svg> Clear filters`;
        button.addEventListener('click', this.clearFilters.bind(this));
        this.status.innerHTML = '';
        this.status.appendChild(button)
    }

    async getProducts(url) {
        const productList = document.querySelector('.products__list');
        productList.classList.add('loading');

        const response = await fetch(url);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const list = doc.querySelector('.products__list');
        const resultCount = doc.querySelector('.products__result-count');
        const footer = doc.querySelector('.products__footer');

        productList.innerHTML = list.innerHTML;
        document.querySelector('.products__result-count').innerHTML = resultCount.innerHTML;
        document.querySelector('.products__footer').innerHTML = footer ? footer.innerHTML : "";

        this.initPagination();
        productList.classList.remove('loading');
    }

    onPrimaryChoiceClick(event) {
        event.preventDefault();
        let url = this.rootElement.dataset.urlBase;

        if (this.primarySelection === event.target) {
            event.target.classList.remove(this.selectedOptionClass);
            this.primarySelection = null;
            this.primaryButton.textContent = this.primaryButtonDefaultText;
        } else {
            this.primaryChoices.forEach(el => {
                el.classList.remove(this.selectedOptionClass);
            })
            event.target.classList.add(this.selectedOptionClass);
            this.primaryButton.textContent = event.target.textContent;
            this.primarySelection = event.target;
            url = event.target.getAttribute('href');
        }

        this.getProducts(url);
        this.populateSecondaryOptions(parseInt(this.primarySelection.dataset.value));
        this.updateStatus();
    }

    onSecondaryChoiceClick(event) {
        event.preventDefault();
        let url = null;

        if (this.currentType) {
            url = this.currentType.dataset.urlBase;
        }

        if (this.secondarySelection === event.target) {
            event.target.classList.remove(this.selectedOptionClass);
            this.secondarySelection = null;
            this.secondaryButton.textContent = "All Subtypes";
        } else {
            this.secondaryChoices.forEach(el => {
                el.classList.remove(this.selectedOptionClass);
            })
            event.target.classList.add(this.selectedOptionClass);
            this.secondaryButton.textContent = event.target.textContent;
            this.secondarySelection = event.target;
            url = event.target.getAttribute('href');
        }

        this.getProducts(url);
        this.updateStatus();
    }

    populateSecondaryOptions(primaryTermId) {
        // primary filter is selectable, but no choices yet or we're resetting
        if (primaryTermId === null) {
            this.secondaryFilter.classList.add('hidden');
            return;
        }
        // we're viewing a subtype archive, nothing to populate
        if (!this.secondaryMenu) {
            return;
        }

        let children = this.terms.filter(obj => obj.parent === primaryTermId);

        if (!children) {
            console.error('Could not find subtype data');
            return;
        }

        this.secondaryMenu.innerHTML = "";
        children.forEach(option => {
            const item = document.createElement('li')
            const anchor = document.createElement('a');
            anchor.classList.add('menu-option');
            anchor.innerHTML = `<svg aria-hidden="true" width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.36382 13L0 8.66667L1.45427 7.22255L4.36382 10.1118L14.5457 0L16 1.44508L4.36382 13Z" fill="#6F7632"/>
                </svg>
                ${option.name}`;
            anchor.setAttribute('href', option.link);
            anchor.setAttribute('role', 'menuitem');
            anchor.setAttribute('tabindex', -1);
            anchor.addEventListener('click', this.onSecondaryChoiceClick.bind(this));
            item.appendChild(anchor);
            this.secondaryMenu.appendChild(item);
        })

        this.secondaryChoices = this.secondaryFilter.querySelectorAll('.menu-option');
        this.secondaryFilter.classList.remove('hidden');
    }

    initPagination() {
        const paginationLinks = document.querySelectorAll('.page-numbers');
        paginationLinks.forEach(el => {
            el.addEventListener('click', this.onPaginationClick.bind(this))
        });
    }

    onPaginationClick(event) {
        event.preventDefault();
        this.getProducts(event.target.getAttribute('href'));
        this.primaryFilter.scrollIntoView({ behavior: "smooth" });
    }
}
